import http from '../http';

interface IGuildData {
  duid: string;
  [key: string]: any;
}
type IBasicPageParams<T = {}> = T & {
  limit: number; // 每页数量
  scroll: string; // 页码
};

type IDateRangeParams<T = {}> = T & {
  startDate: string; // 开始日期
  endDate: string; // 结束日期
};

export default {
  // 获取公会外管信息
  getGuildManagerInfo(data: IGuildData, option: object = {}) {
    return http.get(
      '/guild/manager/{duid}'.replace('{duid}', data.duid),
      data,
      option
    );
  },
  // 创建公会
  createGuild(data: object, option: object = {}) {
    return http.post('/guild/apply', data, option);
  },
  // 获取默认公会外管信息
  getDefaultGuildManagerInfo() {
    return http.get('/guild/manager/default');
  },
  // 获取公会列表
  getGuildList(data: object) {
    return http.get('/guild', data);
  },
  // 获取我的公会详情
  getMineGuildDetail() {
    return http.get('/guild/mine');
  },
  // 获取公会详情
  getGuildDetail(data: {
    gid: string;
    extFields?: string; // 扩展字段
  }) {
    return http.get(
      '/guild/{gid}?extFields={extFields}'.replace('{gid}', data.gid).replace('{extFields}', data.extFields || '')
    );
  },
  // 申请加入公会
  applyJoinGuild(data: { gid: string }) {
    return http.post(
      '/guild/join/apply/{gid}'.replace('{gid}', data.gid),
      data
    );
  },
  // 获取公会banner
  getGuildBanner(data: string) {
    return http.get('/banner/{type}'.replace('{type}', data));
  },
  // 更新公会信息
  updateGuildInfo(data: object) {
    return http.put('/guild', data);
  },
  // 获取加入公会申请列表
  getJoinGuildApplyList(data: IBasicPageParams) {
    return http.get('/guild/join/apply', data);
  },
  // 获取公会加入申请列表数量
  getJoinGuildApplyCount() {
    return http.get('/guild/join/apply/count');
  },
  // 处理加入公会申请
  handleJoinGuildApply(data: { recordId: string }) {
    return http.put(
      '/guild/join/{recordId}/approve'.replace('{recordId}', data.recordId),
      data
    );
  },
  // 处理加入公会申请-拒绝
  handleJoinGuildApplyRefuse(data: { recordId: string }) {
    return http.put(
      '/guild/join/{recordId}/reject'.replace('{recordId}', data.recordId),
      data
    );
  },
  // 获取公会成员列表
  getGuildMemberList(data: IBasicPageParams) {
    return http.get('/guild/member', data);
  },
  // 移出公会成员
  removeGuildMember(data: { gmId: string }) {
    return http.delete(
      '/guild/member/{gmId}'.replace('{gmId}', data.gmId),
      data
    );
  },
  // 设置公会成员角色
  setGuildMemberRole(data: { gmId: string }) {
    return http.put(
      '/guild/member/{gmId}/role'.replace('{gmId}', data.gmId),
      data
    );
  },

  /**
   * 外管-发放礼包
   */
  // 获取外管可以发放的礼包列表
  getGuildManageGiftBag(data: IBasicPageParams) {
    return http.get('/guild/manager/gift_bag', data);
  },
  // 外管发送礼包获取用户信息
  getUserBaseInfo(data: { duid: string }) {
    return http.get('/user/{duid}'.replace('{duid}', data.duid));
  },
  // 外管发送礼包
  sendGuildManageGiftBag(data: { giftBagId: number; receiveUid: string }) {
    return http.post('/guild/manager/gift_bag', data);
  },
  // 外管发送礼包记录
  getGuildManageGiftBagRecordList(data: IBasicPageParams) {
    return http.get('/guild/manager/gift_bag/record', data);
  },

  /**
   * 外管-公会申请
   */
  // 外管获取公会加入申请列表
  getGuildApply(data: IBasicPageParams<{ type: number }>) {
    return http.get('/guild/apply', data);
  },
  // 外管通过公会加入申请
  guildApplyApprove(data: { applyId: string }) {
    return http.put(
      '/guild/apply/{applyId}/approve'.replace('{applyId}', data.applyId)
    );
  },
  // 外管拒绝公会加入申请
  guildApplyReject(data: { applyId: string }) {
    return http.put(
      '/guild/apply/{applyId}/reject'.replace('{applyId}', data.applyId)
    );
  },

  /**
   * 外管-下级BD列表
   */
  // 获取下级BD数据统计
  getGuildManageBDTotal(data: IDateRangeParams) {
    return http.get('/guild/manager/child/count', data);
  },
  // 获取下级BD数据列表
  getGuildManageBDList(data: IBasicPageParams<IDateRangeParams>) {
    return http.get('/guild/manager/child', data);
  },

  /**
   * 外管-下级BD列表-公会数据
   */
  // 获取公会外管信息(通过duid)
  getGuildManageInfoByDuid(data: { duid: string }) {
    return http.get('/guild/manager/{duid}'.replace('{duid}', data.duid));
  },
  // 获取公会外管信息(通过uid)
  getGuildManageInfo(data: { uid: string }) {
    return http.get('/guild/manager/d/{uid}'.replace('{uid}', data.uid));
  },
  // 获取外管-下级BD列表-公会数据-统计
  getGuildManage_BD_GuildData_Total(data: IDateRangeParams<{ uid: string }>) {
    return http.get(
      '/guild/manager/child/{uid}/guild_flow/count'.replace('{uid}', data.uid),
      data
    );
  },
  // 获取外管-下级BD列表-公会数据-列表
  getGuildManage_BD_GuildData_List(
    data: IBasicPageParams<IDateRangeParams<{ uid: string }>>
  ) {
    return http.get(
      '/guild/manager/child/{uid}/guild_flow'.replace('{uid}', data.uid),
      data
    );
  },

  /**
   * 外管-下级BD列表-公会数据-成员数据
   */
  // 获取外管-成员数据-统计
  getGuildManage_MemberData_Total(data: IDateRangeParams<{ gid: string }>) {
    return http.get(
      '/guild/manager/guild/{gid}/member_flow/count'.replace('{gid}', data.gid),
      data
    );
  },
  // 获取外管-成员数据-列表
  getGuildManage_MemberData_List(
    data: IBasicPageParams<IDateRangeParams<{ gid: string }>>
  ) {
    return http.get(
      '/guild/manager/guild/{gid}/member_flow'.replace('{gid}', data.gid),
      data
    );
  },

  /**
   * 外管-下级公会数据
   */
  // 获取外管-下级公会数据-统计
  getGuildManage_GuildData_Total(data: IDateRangeParams) {
    return http.get('/guild/manager/guild_flow/count', data);
  },
  // 获取外管-下级公会数据-列表
  getGuildManage_GuildData_List(data: IBasicPageParams<IDateRangeParams>) {
    return http.get('/guild/manager/guild_flow', data);
  },

  /**
   * 外管和或BD的公会列表
   */
  // 获取外管或BD的公会列表
  getGuildManageGuildList(data: IBasicPageParams) {
    return http.get('/guild/manager/guild', data);
  },

  /**
   * 数据中心
   */
  // 获取数据中心公会数据流水列表
  getGuildFlowList(data: IBasicPageParams<IDateRangeParams>) {
    return http.get('/guild/flow/group/date', data);
  },
  // 获取数据中心公会数据流水统计
  getGuildFlowTotal(data: IDateRangeParams) {
    return http.get('/guild/flow/group/date/count', data);
  },
  // 获取数据中心个人数据流水列表
  getGuildPersonalFlowList(data: IBasicPageParams<IDateRangeParams>) {
    return http.get('/guild/flow/member', data);
  },
  // 获取数据中心个人数据流水统计
  getGuildPersonalFlowTotal(data: IDateRangeParams) {
    return http.get('/guild/flow/member/count', data);
  },
  // 获取数据明细列表
  getDataDetailList(data: IBasicPageParams<{statdate: string}>) {
    return http.get('/guild/flow/member/date', data);
  },
  // 获取数据明细统计
  getDataDetailTotal(data: {statdate: string}) {
    return http.get('/guild/flow/member/date/count', data);
  },

  // 外管赠送魅力值或财富值等级
  upgradeUserLv(data: {lv: number,targetUid: number,type: string}) {
    return http.post('/guild/manager/upgrade/user/lv', data);
  },
  // 获取用户的魅力值分发记录
  getCharmRecordList(data: IBasicPageParams) {
    return http.get('/guild/manager/charm/distribute/record', data);
  },
  // 获取用户的财富值分发记录
  getWealthRecordList(data: IBasicPageParams) {
    return http.get('/guild/manager/wealth/distribute/record', data);
  },
};
